import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  Input,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { WrappedValidate } from '@domgen/dgx-fe-business-models';
import {
  WrappedInvalidPaymentDetails,
  LoggedInUserFormFields,
  PaymentDetails,
  ContractType,
} from '@common/util-models';
import { SavedDirectDebitDetailsFormConfigService } from './saved-direct-debit-details-config.service';
import { SavedDirectDebitDetailsStateService } from './saved-direct-debit-details-state.service';

@Component({
  selector: 'sales-saved-direct-debit-details',
  templateUrl: './saved-direct-debit-details.component.html',
  styleUrls: ['./saved-direct-debit-details.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    SavedDirectDebitDetailsStateService,
    SavedDirectDebitDetailsFormConfigService,
  ],
})
export class SavedDirectDebitDetailsComponent {
  @Input() isHeating = false;
  @Input() productType: ContractType = ContractType.Insurance;

  constructor(
    private readonly directDebitDetailsStateService: SavedDirectDebitDetailsStateService
  ) {}

  @Input() set validate(validate: WrappedValidate | null) {
    if (validate?.validate) {
      this.directDebitDetailsStateService.validate();
    }
  }

  @Input() set invalidPaymentDetailsEntered(
    invalidPaymentDetailsEntered: WrappedInvalidPaymentDetails | null
  ) {
    if (invalidPaymentDetailsEntered) {
      this.directDebitDetailsStateService.invalidPaymentDetailsEntered(
        !!invalidPaymentDetailsEntered.invalidPaymentDetails
      );
    }
  }

  @Input() set cmsFormData(value: LoggedInUserFormFields | null) {
    if (value) {
      this.directDebitDetailsStateService.updateCmsFormData(value);
    }
  }

  @Input() set paymentDetails(value: PaymentDetails | null) {
    if (value) {
      this.directDebitDetailsStateService.updateSavedPaymentDetails(value);
    }
  }

  /**
   * Represents changes to the Payment Day for a customer having pre populated Direct Debit details
   */
  @Output() paymentDay = this.directDebitDetailsStateService.paymentDay$;

  /**
   * The FormGroup representing the read only form or change direct debit details form
   * depending on the mode of operation
   */
  @Output() form = this.directDebitDetailsStateService.form$;

  /**
   * The changed payment details
   */
  @Output() changedPaymentDetails = this.directDebitDetailsStateService
    .changedPaymentDetails$;

  /**
   * Change payment details clicked
   */
  @Output()
  changePaymentDetailsClicked = this.directDebitDetailsStateService
    .changePaymentDetails$;

  vm$ = this.directDebitDetailsStateService.vm$;

  changePaymentDetails() {
    this.directDebitDetailsStateService.changePaymentDetails();
  }

  cancelChangePaymentDetails() {
    this.directDebitDetailsStateService.cancelChangePaymentDetails();
  }

  setEditableForm(formGroup: FormGroup) {
    this.directDebitDetailsStateService.setEditableForm(formGroup);
  }
}
